﻿let toastTimer = null;

function ensureToastRoot() {
    let root = document.getElementById("viwoToastRoot");

    if (root) return root;

    root = document.createElement("div");
    root.id = "viwoToastRoot";
    root.className = "viwo-toast-root";
    document.body.appendChild(root);

    return root;
}

export function showToast(message, options = {}) {
    const {
        type = "success",
        duration = 2200
    } = options;

    const root = ensureToastRoot();

    root.innerHTML = `
        <div class="viwo-toast viwo-toast--${type}">
            <span class="viwo-toast__icon">
                <span class="viwo-toast__circle">
                    <svg viewBox="0 0 64 64" fill="none">
                        <path class="viwo-toast__check"
                              d="M18 33.5L27.5 43L46.5 22.5"
                              stroke="currentColor"
                              stroke-width="5"
                              stroke-linecap="round"
                              stroke-linejoin="round" />
                    </svg>
                </span>
            </span>
            <span class="viwo-toast__text">${message}</span>
        </div>
    `;

    const toast = root.querySelector(".viwo-toast");

    requestAnimationFrame(() => {
        toast?.classList.add("is-visible");
    });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
        toast?.classList.remove("is-visible");
    }, duration);
}